import { render, staticRenderFns } from "./directPkg.vue?vue&type=template&id=f55fc4fe&scoped=true&"
import script from "./directPkg.vue?vue&type=script&lang=js&"
export * from "./directPkg.vue?vue&type=script&lang=js&"
import style0 from "./directPkg.vue?vue&type=style&index=0&id=f55fc4fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55fc4fe",
  null
  
)

export default component.exports